export class ConsentPerson {
  name: string;
  surname: string;
  birth: string;
  nationality: string;
  position: string;

  constructor(person?: ConsentPerson | null) {
    this.name = person?.name ?? "";
    this.surname = person?.surname ?? "";
    this.birth = person?.birth ?? "";
    this.nationality = person?.nationality ?? "";
    this.position = person?.position ?? "";
  }
}
